import React from 'react';

export type GuidedTrainingMaskRect = {
  top: number;
  left: number;
  width: number;
  height: number;
};

type Props = {
  targetRect: GuidedTrainingMaskRect | null;
  fullScreen?: boolean;
  showHighlight?: boolean;
};

export const GuidedTrainingMask = ({
  targetRect,
  fullScreen = !targetRect,
  showHighlight = !!targetRect,
}: Props) => {
  if (fullScreen || !targetRect)
    return <div className="guided-training-dim full" style={{ pointerEvents: 'none' }} />;

  const right = targetRect.left + targetRect.width;
  const bottom = targetRect.top + targetRect.height;

  return (
    <>
      <div className="guided-training-dim" style={{ top: 0, left: 0, right: 0, height: targetRect.top, pointerEvents: 'none' }} />
      <div className="guided-training-dim" style={{ top: bottom, left: 0, right: 0, bottom: 0, pointerEvents: 'none' }} />
      <div className="guided-training-dim" style={{ top: targetRect.top, left: 0, width: targetRect.left, height: targetRect.height, pointerEvents: 'none' }} />
      <div className="guided-training-dim" style={{ top: targetRect.top, left: right, right: 0, height: targetRect.height, pointerEvents: 'none' }} />

      {showHighlight && (
        <div
          className="guided-training-highlight"
          style={{
            top: targetRect.top,
            left: targetRect.left,
            width: targetRect.width,
            height: targetRect.height,
          }}
          aria-hidden="true" />
      )}
    </>
  );
};
